function AppLoader() {

    return <div className='pageloader is-active'></div>
}

export default AppLoader;